import { GoogleAnalytics4 } from "../../helpers/google-analytics-4/GoogleAnalytics4";
import constants from "../../utils/constants";
export class Tracking {
    /**
     * GA4 Purchase Event
     * @param {any} reservation
     * @param {string} defaultCurrency
     */
    static sendPurchaseEvent(reservation, defaultCurrency) {
        const items = reservation.get("roomReservations").map((it, index) => ({
            item_id: this.getRoomId(it),
            item_name: this.getRoomName(it),
            affiliation: this.getReservationHotelTicker(reservation),
            coupon: this.getRoomExtras(it),
            currency: this.getRoomCurrency(it),
            discount: this.getRoomTotalDiscount(it),
            index,
            item_brand: this.getReservationHotelTicker(reservation),
            item_category: "",
            item_category2: "",
            item_category3: "",
            item_category4: "",
            item_category5: "",
            item_list_id: "",
            item_list_name: "",
            item_variant: "",
            location_id: "",
            price: this.getRoomPrice(it),
            quantity: this.getRoomNights(it),
        }));
        GoogleAnalytics4.sendEcommercePurchaseEvent({
            transaction_id: this.getReservationId(reservation),
            currency: defaultCurrency,
            value: this.getReservationTotalRate(reservation),
            coupon: this.getPromoCodes(reservation),
            affiliation: this.getReservationHotelTicker(reservation),
            shipping: 0,
            tax: this.getReservationTotalRateWithoutVAT(reservation),
            items: JSON.parse(JSON.stringify(items)),
        });
    }
    /**
     * GA4 Refund Event
     * @param {string} reservationId
     * @param {string} roomStayId
     * @param {number} quantity
     */
    static sendRefundEvent(reservation, roomStayId, quantity, defaultCurrency) {
        const room = reservation
            .get("roomReservations")
            .find((it) => it.get("confirmationId") === roomStayId);
        GoogleAnalytics4.sendEcommerceRefundEvent({
            transaction_id: this.getReservationId(reservation),
            currency: defaultCurrency,
            value: this.getReservationTotalRate(reservation),
            coupon: this.getPromoCodes(reservation),
            affiliation: this.getReservationHotelTicker(reservation),
            shipping: 0,
            tax: this.getReservationTotalRateWithoutVAT(reservation),
            items: [
                {
                    item_id: this.getRoomId(room),
                    item_name: this.getRoomName(room),
                    affiliation: this.getReservationHotelTicker(reservation),
                    coupon: this.getRoomExtras(room),
                    currency: this.getRoomCurrency(room),
                    discount: this.getRoomTotalDiscount(room),
                    index: 0,
                    item_brand: this.getReservationHotelTicker(reservation),
                    item_category: "",
                    item_category2: "",
                    item_category3: "",
                    item_category4: "",
                    item_category5: "",
                    item_list_id: "",
                    item_list_name: "",
                    item_variant: "",
                    location_id: "",
                    price: this.getRoomPrice(room),
                    quantity: this.getRoomNights(room),
                },
            ],
        });
    }
    static getRoomName(room) {
        return room.get("accommodationTicker");
    }
    static getReservationTotalRate(reservation) {
        const totalRate = reservation.get("roomReservations").reduce((acc, roomStay) => {
            return roomStay.get("totalAmount").get("amount") + acc;
        }, 0);
        return Number(totalRate);
    }
    static getRoomTotalDiscount(room) {
        const totalDiscount = room.get("discounts").reduce((acc, discount) => {
            return discount.get("totalDiscount").get("amount") + acc;
        }, 0);
        return Number(totalDiscount);
    }
    static getPromoCodes(item) {
        return (item.get("promoCodes") && item.get("promoCodes").join(",")) || "";
    }
    static getRoomCurrency(room) {
        return room.get("totalAmount").get("currency");
    }
    static getRoomPrice(room) {
        return Number(room.get("totalAmount").get("amount") / room.get("nights"));
    }
    static getRoomNights(room) {
        return Number(room.get("nights"));
    }
    static getRoomId(room) {
        return room.get("confirmationId");
    }
    static getRoomInventoryTicker(room) {
        return room.get("inventoryTicker");
    }
    static getReservationHotelTicker(reservation) {
        return reservation.get("hotelTicker");
    }
    static getReservationPaymentTicker(reservation) {
        return reservation.get("paymentTicker");
    }
    static getReservationId(reservation) {
        return reservation.get("id");
    }
    static getReservationTotalRateWithoutVAT(reservation) {
        return this.getReservationTotalRate(reservation) * constants.VAT_VALUE;
    }
    static getRoomExtras(room) {
        const selectedServices = room.get("selectedServices");
        return selectedServices
            ? selectedServices.map((extra) => extra.get("ticker")).join(",")
            : "";
    }
}
